const UserRole = {
  ADMIN: 'admin',
  CANDIDATE: 'candidate',
  EMPLOYER: 'employer',
  RECRUITER: 'recruiter',
};


module.exports = UserRole;
